/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Confirm_ArchiveInputs */

const cs_automation_confirm_archive = /** @type {(inputs: Automation_Confirm_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivovat tento workflow? Přestane se odesílat.`)
};

const en_automation_confirm_archive = /** @type {(inputs: Automation_Confirm_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive this workflow? It will no longer be dispatched.`)
};

/**
* | output |
* | --- |
* | "Archive this workflow? It will no longer be dispatched." |
*
* @param {Automation_Confirm_ArchiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_confirm_archive = /** @type {((inputs?: Automation_Confirm_ArchiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Confirm_ArchiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_confirm_archive(inputs)
	return cs_automation_confirm_archive(inputs)
});